import EventBus from './EventBus.js'

export default class AutoCompletion extends EventBus {
    analyseCode(value) {}
    autoComplete(){
        throw "Not implemented!"
    }
}